<template>
  <div class="container">
    <div class="flashes">
      <Alert
        v-if="message"
        key="flashMessage"
        effect="dark"
        :type="message.kind"
        :data-test="`${message.kind}_flash_message`"
        @close="removeMessage()"
        show-icon
        :closable="true"
        :style="{ zIndex: alertZIndex }"
      >
        <template slot="title">
          <span
            v-html="title"
          />
        </template>
        <Button
          v-if="message.button"
          @click="handleClick"
          type="alert"
        >
          {{ $t(`flashMessages.${message.button.key}`, message.params) }}
        </Button>
      </Alert>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      alertZIndex: null,
    };
  },
  computed: {
    ...mapState('flashMessages', ['message']),
    ...mapState('settingsForm', ['dialogOpened']),
    title() {
      if (this.message.text) {
        return this.message.text;
      }

      if (this?.message?.params?.resourceName) {
        const translated = this.$i18n.t(`resources.${this.message.params.resourceName}`);
        Object.assign(this.message.params, { translatedResourceName: translated });
      }

      if (this?.message?.params?.resource?.name) {
        Object.assign(this.message.params, { identificator: this.message.params.resource.name });
      }

      return this.$t(`flashMessages.${this.message.key}`, this.message.params);
    },
  },
  methods: {
    handleClick() {
      if (this.message.button.url) {
        window.location.href = this.message.button.url;
      } else if (this.message.button.action) {
        this.message.button.action();
      }
    },
    removeMessage() {
      this.$store.commit('flashMessages/clearMessage', { root: true });
    },
  },

  watch: {
    dialogOpened() {
      this.alertZIndex = this.dialogOpened ? 10000 : null;
    },
  },
  mounted() {
    this.$store.dispatch('flashMessages/checkMessages');
  },
};
</script>
